import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ModuleRegistry, AllCommunityModules } from 'ag-grid-community';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import '../styles/Admin.css';
import { getApiUrl } from '../services/apiClient';
import AdminAgTable from './AdminAgTable';
import AdminSelectFloatingFilter from './AdminSelectFloatingFilter';

ModuleRegistry.registerModules(AllCommunityModules);

class AdminPage extends Component {
    constructor(props) {
        super(props);
        var self = this;
        this.state = {
            tab: 'stats',
            stats: null,
            statsLoading: false,
            preset: '30d',
            start: '',
            end: '',
            users: [],
            usersLoading: false,
            addUserId: '',
            addUserRole: 'user',
            addUsername: '',
            appsOriginal: {},
            appsEdits: {},
            appsSaving: false,
            appsSaveMessage: '',
            appsSelectedCount: 0,
            appsPageSize: 100,
            appsBulkField: 'category',
            appsBulkValue: '',
            appsBulkLoading: false,
            appsBulkMessage: '',
            appSearch: '',
            commentPkg: '',
            commentUser: '',
            commentResult: '',
            voteDeleteMsg: '',
            userQuickFilter: ''
            ,comments: [],
            commentsLoading: false,
            commentsPage: 1,
            commentsPageSize: 100,
            commentsHasMore: false
            ,showCommentsGrid: false
        };

        this.appsTableRef = React.createRef();
        this.userGridRef = React.createRef();
        this.commentsTableRef = React.createRef();
        this._adminStylesLoaded = false;

	        this.appColumnDefs = [
		            {
		                headerName: '',
		                width: 40,
		                minWidth: 40,
		                maxWidth: 40,
		                pinned: 'left',
		                cellClass: 'bb-checkbox-cell',
		                headerClass: 'bb-checkbox-header',
		                checkboxSelection: true,
		                suppressMenu: true,
		                sortable: false,
	                filter: false,
	                resizable: false
            },
	            {
	                headerName: '',
	                field: 'icon_url',
	                width: 40,
	                minWidth: 40,
	                maxWidth: 40,
	                cellClass: 'bb-icon-cell',
	                filter: false,
	                sortable: false,
	                resizable: false,
                editable: true,
                cellRenderer: function(params) {
                    if (!params.data || !params.data.icon_url) return document.createElement('span');
                    var img = document.createElement('img');
                    img.className = 'bb-app-icon-ag';
                    img.src = params.data.icon_url;
                    img.alt = params.data.app_name || '';
                    return img;
                }
            },
	            { headerName: 'Name', field: 'app_name', filter: 'agTextColumnFilter', minWidth: 180, flex: 1, editable: function() { var role = (self.props.user && self.props.user.role) || 'user'; return role === 'admin' || role === 'superadmin'; } },
	            { headerName: 'Package', field: 'package_name', filter: 'agTextColumnFilter', minWidth: 220 },
	            { headerName: 'Vendor', field: 'vendor', filter: 'agTextColumnFilter', minWidth: 140, editable: function() { var role = (self.props.user && self.props.user.role) || 'user'; return role === 'admin' || role === 'superadmin'; } },
	            {
	                headerName: 'Category',
	                field: 'category',
	                filter: 'agTextColumnFilter',
	                minWidth: 140,
	                editable: true,
	                filterParams: { filterOptions: ['equals'], suppressAndOrCondition: true, defaultOption: 'equals' },
	                floatingFilterComponent: 'adminSelectFloatingFilter',
	                floatingFilterComponentParams: { valuesUrl: getApiUrl('/api/categories'), sortValues: true, allLabel: 'All' }
	            },
		            {
		                headerName: 'Source',
		                field: 'source',
		                filter: 'agTextColumnFilter',
		                minWidth: 120,
		                editable: function() { var role = (self.props.user && self.props.user.role) || 'user'; return role === 'admin' || role === 'superadmin'; },
		                filterParams: { filterOptions: ['equals'], suppressAndOrCondition: true, defaultOption: 'equals' },
		                floatingFilterComponent: 'adminSelectFloatingFilter',
		                floatingFilterComponentParams: { valuesUrl: getApiUrl('/api/sources'), sortValues: true, allLabel: 'All' }
		            },
		            {
		                headerName: 'Version',
		                field: 'version',
		                minWidth: 110,
		                sortable: false,
		                filter: false,
		                floatingFilter: false
		            },
		            {
		                headerName: 'Tags',
		                field: 'tags',
		                filter: 'agTextColumnFilter',
		                minWidth: 180,
		                editable: true,
		                filterParams: { filterOptions: ['equals'], suppressAndOrCondition: true, defaultOption: 'equals' },
		                floatingFilterComponent: 'adminSelectFloatingFilter',
		                floatingFilterComponentParams: { valuesUrl: getApiUrl('/api/tags'), allLabel: 'All' }
		            },
	            { headerName: 'Download', field: 'download_link', filter: false, minWidth: 260, editable: function() { var role = (self.props.user && self.props.user.role) || 'user'; return role === 'admin' || role === 'superadmin'; } },
	            { headerName: 'Direct APK', field: 'direct_apk_link', filter: false, minWidth: 260, editable: function() { var role = (self.props.user && self.props.user.role) || 'user'; return role === 'admin' || role === 'superadmin'; } },
	            {
	                headerName: 'Description',
	                field: 'description',
	                filter: false,
	                minWidth: 320,
	                flex: 2,
	                editable: true,
	                cellEditor: 'agLargeTextCellEditor',
                cellEditorPopup: true,
                cellEditorParams: { maxLength: 6000, cols: 60, rows: 10 }
            },
            { headerName: 'Up', field: 'upvotes', width: 90, sortable: true, filter: false },
            { headerName: 'Down', field: 'downvotes', width: 100, sortable: true, filter: false },
            { headerName: 'Comments', field: 'comment_count', width: 110, sortable: true, filter: false }
        ];

        this.appDefaultColDef = {
            sortable: true,
            filter: true,
            floatingFilter: true,
            resizable: true,
            minWidth: 110
        };

        this.userColumnDefs = [
            { headerName: 'Username', field: 'username', filter: 'agTextColumnFilter', flex: 1, valueFormatter: function(params) { return params.value || 'user'; } },
            { headerName: 'User ID', field: 'user_id', filter: 'agTextColumnFilter', minWidth: 200 },
            {
                headerName: 'Role',
                field: 'role',
                filter: 'agTextColumnFilter',
                minWidth: 140,
                editable: true,
                cellEditor: 'agSelectCellEditor',
                cellEditorParams: { values: ['user', 'moderator', 'admin'] }
            }
        ];

        this.userDefaultColDef = {
            sortable: true,
            filter: true,
            resizable: true,
            flex: 1,
            minWidth: 140
        };

        this.switchTab = this.switchTab.bind(this);
        this.loadStats = this.loadStats.bind(this);
        this.loadUsers = this.loadUsers.bind(this);
        this.addUser = this.addUser.bind(this);
        this.updateUserRole = this.updateUserRole.bind(this);
        this.appsOnGetRows = this.appsOnGetRows.bind(this);
        this.reloadAppsDatasource = this.reloadAppsDatasource.bind(this);
        this.onAppsSelectionChanged = this.onAppsSelectionChanged.bind(this);
        this.onAppSearchChange = this.onAppSearchChange.bind(this);
        this.bulkUpdateSelectedApps = this.bulkUpdateSelectedApps.bind(this);
        this.bulkDeleteSelectedApps = this.bulkDeleteSelectedApps.bind(this);
        this.stripComment = this.stripComment.bind(this);
        this.deleteVote = this.deleteVote.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.onAppCellValueChanged = this.onAppCellValueChanged.bind(this);
        this.saveAppGridEdits = this.saveAppGridEdits.bind(this);
        this.onUserCellValueChanged = this.onUserCellValueChanged.bind(this);
        this.onUserQuickFilterChange = this.onUserQuickFilterChange.bind(this);
        this.loadComments = this.loadComments.bind(this);
        this._onCommentsScroll = this._onCommentsScroll.bind(this);
        // do not bind actionsCellRenderer here; cell renderer will call via params.context.componentParent
        this.reloadCommentsDatasource = this.reloadCommentsDatasource.bind(this);
        this.commentsOnGetRows = this.commentsOnGetRows.bind(this);
        this._onCommentsScroll = this._onCommentsScroll.bind(this);
        // helper to call API using App-provided `api` and auth headers
        this.apiFetch = function(path, opts) {
            try {
                var url = (this.props && this.props.api) ? this.props.api(path) : path;
                var options = Object.assign({}, opts || {});
                if (!options.credentials) options.credentials = 'include';
                options.headers = Object.assign({}, (this.props.getAuthHeaders ? this.props.getAuthHeaders() : {}), options.headers || {});
                return fetch(url, options);
            } catch (e) {
                return Promise.reject(e);
            }
        }.bind(this);
        this.commentsColumnDefs = [
            {
                headerName: '',
                field: 'icon_url',
                width: 30,
                cellClass: 'bb-icon-cell',
                cellRenderer: function(params) {
                    if (!params.data || !params.data.icon_url) return document.createElement('span');
                    var img = document.createElement('img');
                    img.className = 'bb-app-icon-ag';
                    img.src = params.data.icon_url;
                    img.alt = params.data.app_name || '';
                    return img;
                }
            },
            { headerName: 'App', field: 'app_name', filter: 'agTextColumnFilter', sortable: true, flex: 1 },
            {
                headerName: 'User',
                filter: 'agTextColumnFilter',
                sortable: true,
                width: 100,
                cellRenderer: function(params) {
                    try {
                        var u = params.data && (params.data.username || params.data.user_id);
                        if (!u) return document.createElement('span');
                        var span = document.createElement('span');
                        span.textContent = '@' + u;
                        return span;
                    } catch (e) { return document.createElement('span'); }
                }
            },
            {
                headerName: '',
                width: 40,
                sortable: true,
                cellRenderer: function(params) {
                    try {
                        var v = params.data && params.data.vote_type;
                        if (!v) return document.createElement('span');
                        var span = document.createElement('span');
                        span.textContent = (v === 'up') ? '👍' : ((v === 'down') ? '👎' : v);
                        return span;
                    } catch (e) { return document.createElement('span'); }
                }
            },
            {
                headerName: 'Comment',
                flex: 3,
                cellRenderer: function(params) {
                    var d = document.createElement('div');
                    d.className = 'bb-comment-cell';
                    d.textContent = (params.data && params.data.comment) ? params.data.comment : '';
                    d.style.cursor = 'pointer';
                    d.addEventListener('click', function(e) {
                        e.stopPropagation();
                        try {
                            var comp = params.context && params.context.componentParent;
                            if (comp && comp.openCommentModal) comp.openCommentModal(params.data);
                        } catch (err) {}
                    });
                    d.title = '(Click to view full comment)';
                    return d;
                }
            },
            {
                headerName: 'Date',
                width: 140,
                sortable: true,
                cellRenderer: function(params) {
                    try {
                        var dstr = params.data && params.data.updated_at;
                        if (!dstr) return document.createElement('span');
                        var d = new Date(dstr);
                        var s = isNaN(d.getTime()) ? dstr : d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
                        var span = document.createElement('span');
                        span.textContent = s;
                        return span;
                    } catch (e) { return document.createElement('span'); }
                }
            },
            {
                headerName: 'Actions',
                field: 'actions',
                width: 200,
                cellRenderer: function(params) {
                    var comp = params.context && params.context.componentParent;
                    if (!comp || !comp.actionsCellRenderer) return document.createElement('span');
                    return comp.actionsCellRenderer(params);
                }
            }
        ];
        this.commentsDefaultColDef = { sortable: true, filter: true, resizable: true };
    }

    componentDidMount() {
        try {
            if (this.state && this.state.tab === 'stats') {
                this.loadStats();
            }
        } catch (e) {}
    }

    componentWillUnmount() {
        try {
            this.commentsTableRef = null;
        } catch (e) {}
    }

    _onCommentsScroll() {
        // Placeholder for future scroll-based comment pagination
    }

    

    reloadCommentsDatasource() {
        try {
            if (this.commentsTableRef && this.commentsTableRef.current && typeof this.commentsTableRef.current.refresh === 'function') {
                try { this.commentsTableRef.current.refresh(); } catch (e) {}
            }
        } catch (e) {}
    }

    commentsOnGetRows(request) {
        var comp = this;
        try {
            var bs = this.state.commentsPageSize || 100;
            // Determine requested page from startRow/endRow if provided, otherwise fallback to page=1
            var startRow = (typeof request.startRow !== 'undefined') ? request.startRow : 0;
            var endRow = (typeof request.endRow !== 'undefined') ? request.endRow : (startRow + bs - 1);
            var page = Math.floor(startRow / bs) + 1;
            var params = [];
            params.push('page=' + page);
            params.push('page_size=' + bs);

            // map filterModel -> package/user where applicable
            try {
                var filterModel = request.filterModel || {};
                if (filterModel.package_name && filterModel.package_name.filter) {
                    params.push('package=' + encodeURIComponent(filterModel.package_name.filter));
                }
                if (filterModel.username && filterModel.username.filter) {
                    params.push('user=' + encodeURIComponent(filterModel.username.filter));
                }
                // if the parent state contains explicit filters, include them as fallback
            } catch (e) {}

            try {
                var sortModel = request.sortModel && request.sortModel.length ? request.sortModel[0] : null;
                if (sortModel && sortModel.colId) {
                    params.push('sort_col=' + encodeURIComponent(sortModel.colId));
                    params.push('sort_dir=' + encodeURIComponent(sortModel.sort));
                }
            } catch (e) {}

            if (this.state && this.state.commentPkg && params.indexOf('package=') === -1) params.push('package=' + encodeURIComponent(this.state.commentPkg));
            if (this.state && this.state.commentUser && params.indexOf('user=') === -1) params.push('user=' + encodeURIComponent(this.state.commentUser));

            var qs = params.length ? ('?' + params.join('&')) : '';
            return this.apiFetch('/api/admin/comments' + qs)
                .then(function(res) { if (!res.ok) throw new Error('Failed'); return res.json(); })
                .then(function(data) {
                    return { rows: data && data.comments ? data.comments : [], total: (typeof data.total !== 'undefined' ? data.total : -1) };
                })
                .catch(function() { return { rows: [], total: -1 }; });
        } catch (e) { return Promise.resolve({ rows: [], total: -1 }); }
    }
    actionsCellRenderer(params) {
        var self = this;
        var container = document.createElement('div');
        container.style.display = 'inline-flex';
        container.style.gap = '6px';
        var stripBtn = document.createElement('button');
        stripBtn.className = 'bb-btn bb-btn-ag bb-btn-secondary bb-btn-xs';
        stripBtn.innerText = 'Strip Comment';
        stripBtn.addEventListener('click', function(e) { e.stopPropagation(); if (confirm('Strip the comment for this vote?')) self.stripCommentFor(params.data); });
        container.appendChild(stripBtn);
        var role = (this.props.user && this.props.user.role) || 'user';
        if (role === 'admin' || role === 'superadmin' || role === 'moderator') {
            var delBtn = document.createElement('button');
            delBtn.className = 'bb-btn bb-btn-ag bb-btn-danger bb-btn-xs';
            delBtn.style.marginLeft = '6px';
            delBtn.innerText = 'Delete';
            delBtn.addEventListener('click', function(e) { e.stopPropagation(); if (confirm('Delete vote for this comment?')) self.deleteVoteFor(params.data); });
            container.appendChild(delBtn);
        }
        return container;
    }

    openCommentModal(row) {
        this.setState({ modalVisible: true, modalRow: row });
    }

    closeCommentModal() {
        this.setState({ modalVisible: false, modalRow: null });
    }

    formatDate(datestr) {
        try {
            var d = new Date(datestr);
            if (isNaN(d.getTime())) return datestr;
            var opts = { day: '2-digit', month: 'short', year: 'numeric' };
            return d.toLocaleDateString('en-GB', opts);
        } catch (e) { return datestr; }
    }
    switchTab(tab) {
        this.setState({ tab: tab, commentResult: '', voteDeleteMsg: '' });
        var role = (this.props.user && this.props.user.role) || 'user';
        var allowApps = !this.props.isLegacy && (role === 'admin' || role === 'superadmin' || role === 'moderator');
        var allowUsers = !this.props.isLegacy && role === 'superadmin';
        if (tab === 'users' && allowUsers) {
            this.loadUsers();
            if (typeof window !== 'undefined') window.removeEventListener('scroll', this._onCommentsScroll);
        }
        if (tab === 'stats') {
            this.loadStats();
        }
        if (tab === 'comments' && (role === 'admin' || role === 'superadmin' || role === 'moderator')) {
            // Defer rendering/initialization of the comments grid slightly to avoid AG Grid resize/render races.
            try { this.setState({ tab: 'comments', showCommentsGrid: false, commentResult: '', voteDeleteMsg: '' }); } catch (e) {}
            setTimeout(function() {
                try { this.setState({ showCommentsGrid: true }); } catch (e) {}
                if (typeof this.reloadCommentsDatasource === 'function') {
                    this.reloadCommentsDatasource();
                }
            }.bind(this), 50);
        } else {
            // leaving comments tab: clear table ref to avoid calling grid API on hidden/destroyed grid
            try { this.commentsTableRef = null; } catch (e) {}
        }
    }

    loadComments(page, reset) {
        var self = this;
        var p = page || 1;
        var pageSize = this.state.commentsPageSize || 100;
        var params = [];
        params.push('page=' + p);
        params.push('page_size=' + pageSize);
        if (this.state.commentPkg) params.push('package=' + encodeURIComponent(this.state.commentPkg));
        if (this.state.commentUser) params.push('user=' + encodeURIComponent(this.state.commentUser));
        this.setState({ commentsLoading: true });
        fetch(this.props.api('/api/admin/comments') + '?' + params.join('&'), {
            credentials: 'include',
            headers: Object.assign({}, (this.props.getAuthHeaders ? this.props.getAuthHeaders() : {}))
        })
            .then(function(res) { if (!res.ok) throw new Error('Failed'); return res.json(); })
            .then(function(data) {
                var comments = data && data.comments ? data.comments : [];
                var total = data && data.total ? data.total : 0;
                var newList = reset ? comments : (self.state.comments || []).concat(comments);
                var hasMore = newList.length < total;
                self.setState({ comments: newList, commentsPage: p, commentsHasMore: hasMore, commentsLoading: false });
            })
            .catch(function() { self.setState({ commentsLoading: false }); });
    }

    stripCommentFor(row) {
        var self = this;
        if (!row || !row.package_name || !row.user_id) return;
        fetch(this.props.api('/api/admin/comments/strip'), {
            method: 'POST',
            credentials: 'include',
            headers: Object.assign({ 'Content-Type': 'application/json' }, (this.props.getAuthHeaders ? this.props.getAuthHeaders() : {})),
            body: JSON.stringify({ package_name: row.package_name, user_id: row.user_id })
        })
            .then(function(res) { return res.json(); })
            .then(function(data) {
                self.setState({ commentResult: 'Stripped comment for ' + row.user_id + ' / ' + row.package_name });
                // Refresh comments via datasource
                if (typeof self.reloadCommentsDatasource === 'function') self.reloadCommentsDatasource();
            })
            .catch(function() { self.setState({ commentResult: 'Failed to strip comment' }); });
    }

    deleteVoteFor(row) {
        var self = this;
        if (!row || !row.package_name || !row.user_id) return;
        fetch(this.props.api('/api/admin/votes/delete'), {
            method: 'POST',
            credentials: 'include',
            headers: Object.assign({ 'Content-Type': 'application/json' }, (this.props.getAuthHeaders ? this.props.getAuthHeaders() : {})),
            body: JSON.stringify({ package_name: row.package_name, user_id: row.user_id })
        })
            .then(function(res) { return res.json(); })
            .then(function(data) {
                self.setState({ voteDeleteMsg: 'Deleted vote for ' + row.user_id + ' / ' + row.package_name });
                if (typeof self.reloadCommentsDatasource === 'function') self.reloadCommentsDatasource();
            })
            .catch(function() { self.setState({ voteDeleteMsg: 'Failed to delete vote' }); });
    }

    loadStats() {
        var self = this;
        this.setState({ statsLoading: true });
        var params = [];
        if (this.state.preset) params.push('preset=' + encodeURIComponent(this.state.preset));
        if (this.state.start) params.push('start=' + encodeURIComponent(this.state.start));
        if (this.state.end) params.push('end=' + encodeURIComponent(this.state.end));
        var qs = params.length ? ('?' + params.join('&')) : '';
        this.apiFetch('/api/admin/stats' + qs)
            .then(function(res) { return res.json(); })
            .then(function(data) {
                self.setState({ stats: data, statsLoading: false });
            })
            .catch(function() { self.setState({ statsLoading: false }); });
    }

    loadUsers() {
        var self = this;
        this.setState({ usersLoading: true });
        this.apiFetch('/api/admin/users')
            .then(function(res) { return res.json(); })
            .then(function(data) {
                self.setState({ users: data.users || [], usersLoading: false });
            })
            .catch(function() { self.setState({ usersLoading: false }); });
    }

    addUser() {
        var self = this;
        this.apiFetch('/api/admin/users', {
            method: 'POST',
            body: JSON.stringify({
                user_id: this.state.addUserId,
                role: this.state.addUserRole,
                username: this.state.addUsername
            })
        })
            .then(function(res) { return res.json(); })
            .then(function() { self.loadUsers(); self.setState({ addUserId: '', addUsername: '' }); })
            .catch(function() {});
    }

    updateUserRole(userId, role, username) {
        var self = this;
        this.apiFetch('/api/admin/users', {
            method: 'POST',
            body: JSON.stringify({ user_id: userId, role: role, username: username })
        })
            .then(function(res) { return res.json(); })
            .then(function() { self.loadUsers(); })
            .catch(function() {});
    }

    onAppSearchChange(e) {
        var self = this;
        var val = e && e.target ? e.target.value : '';
        this.setState({ appSearch: val, appsBulkMessage: '' });
        try {
            if (this._appsSearchTimer) clearTimeout(this._appsSearchTimer);
            this._appsSearchTimer = setTimeout(function() { try { self.reloadAppsDatasource(); } catch (e) {} }, 250);
        } catch (e) {}
    }

    reloadAppsDatasource() {
        try {
            if (this.appsTableRef && this.appsTableRef.current && typeof this.appsTableRef.current.refresh === 'function') {
                try { this.appsTableRef.current.refresh(); } catch (e) {}
            }
        } catch (e) {}
    }

    appsOnGetRows(request) {
        var comp = this;
        try {
            var bs = this.state.appsPageSize || 100;
            var startRow = (typeof request.startRow !== 'undefined') ? request.startRow : 0;
            var page = Math.floor(startRow / bs) + 1;
            var params = [];
            params.push('page=' + page);
            params.push('page_size=' + bs);

            if (this.state && this.state.appSearch) params.push('q=' + encodeURIComponent(this.state.appSearch));

	            try {
	                var filterModel = request.filterModel || {};
	                var encodeCsv = function(values) {
	                    try {
	                        return (values || []).map(function(v) { return encodeURIComponent(String(v)); }).join(',');
	                    } catch (e) { return ''; }
	                };

	                // Text filters
	                ['app_name', 'package_name', 'vendor', 'source'].forEach(function(col) {
	                    var f = filterModel[col];
	                    if (f && typeof f.filter !== 'undefined' && f.filter !== null && String(f.filter).trim() !== '') {
	                        params.push(col + '=' + encodeURIComponent(String(f.filter)));
	                    }
	                });

	                // Dropdown filters
	                var cat = filterModel.category;
	                if (cat) {
	                    if (cat.values && cat.values.length) params.push('categories=' + encodeCsv(cat.values));
	                    else if (cat.filter) params.push('category=' + encodeURIComponent(String(cat.filter)));
	                }
	                var ver = filterModel.version;
	                if (ver) {
	                    if (ver.values && ver.values.length) params.push('versions=' + encodeCsv(ver.values));
	                    else if (ver.filter) params.push('version=' + encodeURIComponent(String(ver.filter)));
	                }
	                var tg = filterModel.tags;
	                if (tg) {
	                    if (tg.values && tg.values.length) params.push('tags_any=' + encodeCsv(tg.values));
	                    else if (tg.filter) params.push('tags=' + encodeURIComponent(String(tg.filter)));
	                }
	            } catch (e) {}

            try {
                var sortModel = request.sortModel && request.sortModel.length ? request.sortModel[0] : null;
                if (sortModel && sortModel.colId) {
                    params.push('sort_col=' + encodeURIComponent(sortModel.colId));
                    params.push('sort_dir=' + encodeURIComponent(sortModel.sort));
                }
            } catch (e) {}

            var qs = params.length ? ('?' + params.join('&')) : '';
            return this.apiFetch('/api/admin/apps' + qs)
                .then(function(res) { if (!res.ok) throw new Error('Failed'); return res.json(); })
                .then(function(data) {
                    var rows = (data && data.apps) ? data.apps : [];
                    var edits = comp.state.appsEdits || {};
                    var merged = rows.map(function(r) {
                        try {
                            if (!r || !r.package_name) return r;
                            var patch = edits[r.package_name];
                            return patch ? Object.assign({}, r, patch) : r;
                        } catch (e) { return r; }
                    });
                    return { rows: merged, total: (typeof data.total !== 'undefined') ? data.total : -1 };
                })
                .catch(function() { return { rows: [], total: -1 }; });
        } catch (e) { return Promise.resolve({ rows: [], total: -1 }); }
    }

    onAppsSelectionChanged() {
        var count = 0;
        try {
            if (this.appsTableRef && this.appsTableRef.current && this.appsTableRef.current.gridApi && typeof this.appsTableRef.current.gridApi.getSelectedRows === 'function') {
                var rows = this.appsTableRef.current.gridApi.getSelectedRows();
                count = rows && rows.length ? rows.length : 0;
            }
        } catch (e) {}
        this.setState({ appsSelectedCount: count });
    }

    bulkUpdateSelectedApps() {
        var self = this;
        if (this.state.appsBulkLoading) return;
        var role = (this.props.user && this.props.user.role) || 'user';
        var isAdmin = role === 'admin' || role === 'superadmin';
        var allowedFields = isAdmin ? ['vendor', 'category', 'tags', 'source'] : ['category', 'tags'];
        var field = (this.state.appsBulkField || '').trim();
        var value = (this.state.appsBulkValue || '').trim();
        if (!field || allowedFields.indexOf(field) === -1) {
            this.setState({ appsBulkMessage: 'Choose a valid bulk field' });
            return;
        }
        if (!value) {
            this.setState({ appsBulkMessage: 'Enter a value' });
            return;
        }
        var api = this.appsTableRef && this.appsTableRef.current && this.appsTableRef.current.gridApi;
        var rows = (api && typeof api.getSelectedRows === 'function') ? (api.getSelectedRows() || []) : [];
        var pkgs = rows.map(function(r) { return r && r.package_name; }).filter(Boolean);
        if (!pkgs.length) {
            this.setState({ appsBulkMessage: 'No rows selected' });
            return;
        }
        var fields = {}; fields[field] = value;
        this.setState({ appsBulkLoading: true, appsBulkMessage: '' });
        this.apiFetch('/api/admin/apps/bulk', {
            method: 'POST',
            body: JSON.stringify({ action: 'update', packages: pkgs, fields: fields })
        })
            .then(function(res) { return res.json(); })
            .then(function(data) {
                if (!(data && data.ok)) {
                    self.setState({ appsBulkLoading: false, appsBulkMessage: (data && data.error) ? data.error : 'Failed' });
                    return;
                }
                var nextEdits = Object.assign({}, self.state.appsEdits || {});
                var nextOriginal = Object.assign({}, self.state.appsOriginal || {});
                pkgs.forEach(function(pkg) { delete nextEdits[pkg]; delete nextOriginal[pkg]; });
                self.setState({ appsBulkLoading: false, appsBulkMessage: 'Bulk updated', appsEdits: nextEdits, appsOriginal: nextOriginal, appsSaveMessage: '' });
                self.reloadAppsDatasource();
            })
            .catch(function() { self.setState({ appsBulkLoading: false, appsBulkMessage: 'Failed' }); });
    }

    bulkDeleteSelectedApps() {
        var self = this;
        if (this.state.appsBulkLoading) return;
        var role = (this.props.user && this.props.user.role) || 'user';
        var isAdmin = role === 'admin' || role === 'superadmin';
        if (!isAdmin) return;
        var api = this.appsTableRef && this.appsTableRef.current && this.appsTableRef.current.gridApi;
        var rows = (api && typeof api.getSelectedRows === 'function') ? (api.getSelectedRows() || []) : [];
        var pkgs = rows.map(function(r) { return r && r.package_name; }).filter(Boolean);
        if (!pkgs.length) {
            this.setState({ appsBulkMessage: 'No rows selected' });
            return;
        }
        if (typeof window !== 'undefined') {
            try {
                if (!window.confirm('Delete ' + pkgs.length + ' app(s)?')) return;
            } catch (e) {}
        }
        this.setState({ appsBulkLoading: true, appsBulkMessage: '' });
        this.apiFetch('/api/admin/apps/bulk', {
            method: 'POST',
            body: JSON.stringify({ action: 'delete', packages: pkgs })
        })
            .then(function(res) { return res.json(); })
            .then(function(data) {
                if (!(data && data.ok)) {
                    self.setState({ appsBulkLoading: false, appsBulkMessage: (data && data.error) ? data.error : 'Failed' });
                    return;
                }
                var nextEdits = Object.assign({}, self.state.appsEdits || {});
                var nextOriginal = Object.assign({}, self.state.appsOriginal || {});
                pkgs.forEach(function(pkg) { delete nextEdits[pkg]; delete nextOriginal[pkg]; });
                self.setState({ appsBulkLoading: false, appsBulkMessage: 'Deleted', appsEdits: nextEdits, appsOriginal: nextOriginal, appsSaveMessage: '', appsSelectedCount: 0 });
                self.reloadAppsDatasource();
            })
            .catch(function() { self.setState({ appsBulkLoading: false, appsBulkMessage: 'Failed' }); });
    }

    stripComment() {
        var self = this;
        this.apiFetch('/api/admin/comments/strip', {
            method: 'POST',
            body: JSON.stringify({ package_name: this.state.commentPkg, user_id: this.state.commentUser })
        })
            .then(function(res) { return res.json(); })
            .then(function(data) { self.setState({ commentResult: data && data.ok ? 'Comment removed' : (data.error || 'Failed') }); })
            .catch(function() { self.setState({ commentResult: 'Failed' }); });
    }

    deleteVote() {
        var self = this;
        this.apiFetch('/api/admin/votes/delete', {
            method: 'POST',
            body: JSON.stringify({ package_name: this.state.commentPkg, user_id: this.state.commentUser })
        })
            .then(function(res) { return res.json(); })
            .then(function(data) { self.setState({ voteDeleteMsg: data && data.ok ? 'Vote deleted' : (data.error || 'Failed') }); })
            .catch(function() { self.setState({ voteDeleteMsg: 'Failed' }); });
    }

    handleInput(field, value) {
        var patch = {};
        patch[field] = value;
        this.setState(patch);
    }

    onUserCellValueChanged(params) {
        if (!params || !params.data) return;
        var data = params.data;
        var newRole = params.newValue;
        if (newRole && newRole !== params.oldValue) {
            this.updateUserRole(data.user_id, newRole, data.username);
        }
    }

    onAppCellValueChanged(params) {
        if (!params || !params.data || !params.colDef) return;
        var pkg = params.data.package_name;
        var field = params.colDef.field;
        if (!pkg || !field) return;

        var normNew = (params.newValue === undefined || params.newValue === null) ? '' : params.newValue;

        var nextOriginal = Object.assign({}, this.state.appsOriginal || {});
        var rowOriginal = Object.assign({}, nextOriginal[pkg] || {});
        if (!Object.prototype.hasOwnProperty.call(rowOriginal, field)) {
            rowOriginal[field] = (params.oldValue === undefined || params.oldValue === null) ? '' : params.oldValue;
            nextOriginal[pkg] = rowOriginal;
        }
        var normOrig = (rowOriginal[field] === undefined || rowOriginal[field] === null) ? '' : rowOriginal[field];

        var nextEdits = Object.assign({}, this.state.appsEdits || {});
        var nextRowEdits = Object.assign({}, nextEdits[pkg] || {});
        if (String(normNew) !== String(normOrig)) nextRowEdits[field] = normNew;
        else delete nextRowEdits[field];

        if (Object.keys(nextRowEdits).length) nextEdits[pkg] = nextRowEdits;
        else delete nextEdits[pkg];

        this.setState({ appsOriginal: nextOriginal, appsEdits: nextEdits, appsSaveMessage: '' });
    }

    saveAppGridEdits() {
        var self = this;
        if (this.state.appsSaving) return;
        var edits = this.state.appsEdits || {};
        var pkgs = Object.keys(edits);
        if (!pkgs.length) return;

        var role = (this.props.user && this.props.user.role) || 'user';
        var isAdmin = role === 'admin' || role === 'superadmin';
        var allowed = isAdmin
            ? ['app_name', 'vendor', 'category', 'source', 'tags', 'download_link', 'direct_apk_link', 'icon_url', 'description']
            : ['description', 'icon_url', 'tags', 'category'];

        this.setState({ appsSaving: true, appsSaveMessage: '' });

        var requests = pkgs.map(function(pkg) {
            var rowEdits = edits[pkg] || {};
            var payload = { package_name: pkg };
            allowed.forEach(function(k) {
                if (Object.prototype.hasOwnProperty.call(rowEdits, k)) payload[k] = rowEdits[k];
            });
            if (Object.keys(payload).length === 1) {
                return Promise.resolve({ pkg: pkg, ok: true, sent: {} });
            }
            return self.apiFetch('/api/admin/app', {
                method: 'POST',
                body: JSON.stringify(payload)
            })
                .then(function(res) { return res.json(); })
                .then(function(data) { return { pkg: pkg, ok: !!(data && data.ok), error: data && data.error, sent: payload }; })
                .catch(function(err) { return { pkg: pkg, ok: false, error: (err && err.message) ? err.message : 'Failed', sent: payload }; });
        });

        Promise.all(requests)
            .then(function(results) {
                var nextOriginal = Object.assign({}, self.state.appsOriginal || {});
                var nextEdits = Object.assign({}, edits);
                var okCount = 0;
                var failed = [];
                results.forEach(function(r) {
                    if (r.ok) {
                        okCount += 1;
                        var sentFields = Object.assign({}, r.sent || {});
                        delete sentFields.package_name;
                        if (!nextOriginal[r.pkg]) nextOriginal[r.pkg] = {};
                        nextOriginal[r.pkg] = Object.assign({}, nextOriginal[r.pkg], sentFields);
                        delete nextEdits[r.pkg];
                    } else {
                        failed.push(r);
                    }
                });
                var msg = failed.length
                    ? ('Saved ' + okCount + '/' + results.length)
                    : 'Saved';
                self.setState({ appsSaving: false, appsOriginal: nextOriginal, appsEdits: nextEdits, appsSaveMessage: msg });
            })
            .catch(function() { self.setState({ appsSaving: false, appsSaveMessage: 'Failed' }); });
    }

    onUserQuickFilterChange(e) {
        var val = e && e.target ? e.target.value : '';
        this.setState({ userQuickFilter: val });
        try {
            if (this.userGridRef && this.userGridRef.current && this.userGridRef.current.api) {
                this.userGridRef.current.api.setQuickFilter(val);
            }
        } catch (err) {}
    }

    renderStats() {
        var stats = this.state.stats || {};
        var totals = stats.totals || {};
        var voteSeries = stats.votes_by_day || [];
        var topApps = stats.top_apps || [];
        return React.createElement('div', { className: 'bb-admin-section' },
            React.createElement('div', { className: 'bb-admin-filters' },
                React.createElement('div', null,
                    React.createElement('input', {
                        type: 'datetime-local',
                        value: this.state.start,
                        'aria-label': 'Start',
                        onChange: function(e) { this.setState({ start: e.target.value }); }.bind(this),
                        className: 'bb-select'
                    })
                ),
                React.createElement('div', null,
                    React.createElement('input', {
                        type: 'datetime-local',
                        value: this.state.end,
                        'aria-label': 'End',
                        onChange: function(e) { this.setState({ end: e.target.value }); }.bind(this),
                        className: 'bb-select'
                    })
                ),
                React.createElement('div', null,
                    React.createElement('select', {
                        value: this.state.preset,
                        onChange: function(e) { this.setState({ preset: e.target.value }, this.loadStats); }.bind(this),
                        className: 'bb-select'
                    },
                        React.createElement('option', { value: '', disabled: true }, 'Presets'),
                        React.createElement('option', { value: '7d' }, 'Last 7 days'),
                        React.createElement('option', { value: '30d' }, 'Last 30 days'),
                        React.createElement('option', { value: 'all' }, 'All time')
                    )
                ),
                React.createElement('div', null,
                    React.createElement('button', { className: 'bb-btn bb-btn-secondary bb-btn-sm', onClick: this.loadStats, style: { whiteSpace: 'nowrap' } }, 'Apply')
                )
            ),
            this.state.statsLoading ? React.createElement('div', { className: 'bb-comments-loading' }, 'Loading stats...') :
                React.createElement('div', null,
                    React.createElement('div', { className: 'bb-admin-grid' },
                        React.createElement('div', { className: 'bb-admin-card' },
                            React.createElement('div', { className: 'bb-admin-card-label' }, 'Apps'),
                            React.createElement('div', { className: 'bb-admin-card-value' }, totals.apps || 0)
                        ),
                        React.createElement('div', { className: 'bb-admin-card' },
                            React.createElement('div', { className: 'bb-admin-card-label' }, 'Votes'),
                            React.createElement('div', { className: 'bb-admin-card-value' }, totals.votes || 0)
                        ),
                        React.createElement('div', { className: 'bb-admin-card' },
                            React.createElement('div', { className: 'bb-admin-card-label' }, 'Comments'),
                            React.createElement('div', { className: 'bb-admin-card-value' }, totals.comments || 0)
                        ),
                        React.createElement('div', { className: 'bb-admin-card' },
                            React.createElement('div', { className: 'bb-admin-card-label' }, 'Unique voters'),
                            React.createElement('div', { className: 'bb-admin-card-value' }, totals.unique_voters || 0)
                        )
                    ),
                    React.createElement('div', { className: 'bb-admin-subsection' },
                        React.createElement('h4', null, 'Votes by Day'),
                        React.createElement('div', { className: 'bb-admin-list' },
                            voteSeries.map(function(v) {
                                return React.createElement('div', { key: v.day, className: 'bb-admin-row' },
                                    React.createElement('span', null, v.day),
                                    React.createElement('span', null, 'Up: ' + v.upvotes + ' / Down: ' + v.downvotes + ' / Total: ' + v.total)
                                );
                            })
                        )
                    ),
                    React.createElement('div', { className: 'bb-admin-subsection' },
                        React.createElement('h4', null, 'Top Apps'),
                        React.createElement('div', { className: 'bb-admin-list' },
                            topApps.map(function(a) {
                                return React.createElement('div', { key: a.package_name, className: 'bb-admin-row' },
                                    React.createElement('span', null, a.app_name || a.package_name),
                                    React.createElement('span', null, '👍 ' + (a.upvotes || 0) + ' / 👎 ' + (a.downvotes || 0))
                                );
                            })
                        )
                    )
                )
        );
    }

    renderUsers() {
        var self = this;
        if (this.props.user.role !== 'superadmin') {
            return React.createElement('p', null, 'Superadmin only');
        }
        return React.createElement('div', { className: 'bb-admin-section' },
            React.createElement('div', { className: 'bb-admin-inline' },
                React.createElement('input', {
                    type: 'text',
                    placeholder: 'Discord user id',
                    value: this.state.addUserId,
                    onChange: function(e) { self.handleInput('addUserId', e.target.value); }
                }),
                React.createElement('input', {
                    type: 'text',
                    placeholder: 'Username (optional)',
                    value: this.state.addUsername,
                    onChange: function(e) { self.handleInput('addUsername', e.target.value); }
                }),
                React.createElement('select', {
                    value: this.state.addUserRole,
                    onChange: function(e) { self.handleInput('addUserRole', e.target.value); }
                },
                    React.createElement('option', { value: 'user' }, 'User'),
                    React.createElement('option', { value: 'moderator' }, 'Moderator'),
                    React.createElement('option', { value: 'admin' }, 'Admin')
                ),
                React.createElement('button', { className: 'bb-btn bb-btn-secondary bb-btn-sm', onClick: this.addUser }, 'Add/Update')
            ),
            React.createElement('div', { className: 'bb-admin-grid-shell' },
                React.createElement('div', { className: 'bb-admin-grid-toolbar' },
                    React.createElement('input', {
                        type: 'text',
                        placeholder: 'Quick filter users',
                        value: this.state.userQuickFilter,
                        onChange: this.onUserQuickFilterChange
                    }),
                    React.createElement('button', { className: 'bb-btn bb-btn-secondary bb-btn-xs', onClick: this.loadUsers }, 'Reload')
                ),
                this.state.usersLoading ? React.createElement('div', null, 'Loading users...') :
                    React.createElement('div', { className: 'ag-theme-bb-admin bb-admin-grid-container' },
                        React.createElement(AgGridReact, {
                            ref: this.userGridRef,
                            rowData: this.state.users,
                            columnDefs: this.userColumnDefs,
                            defaultColDef: this.userDefaultColDef,
                            rowSelection: 'single',
                            suppressCellFocus: true,
                            animateRows: true,
                            quickFilterText: this.state.userQuickFilter,
                            onCellValueChanged: this.onUserCellValueChanged
                        })
                    )
            )
        );
    }

    renderApps() {
        var self = this;
        var role = (this.props.user && this.props.user.role) || 'user';
        var isAdmin = role === 'admin' || role === 'superadmin';
        var pendingAppEdits = Object.keys(this.state.appsEdits || {}).length;
        var bulkFields = isAdmin
            ? [
                { value: 'vendor', label: 'Vendor' },
                { value: 'category', label: 'Category' },
                { value: 'tags', label: 'Tags' },
                { value: 'source', label: 'Source' }
            ]
            : [
                { value: 'category', label: 'Category' },
                { value: 'tags', label: 'Tags' }
            ];
        return React.createElement('div', { className: 'bb-admin-section' },
            React.createElement('div', { className: 'bb-admin-grid-shell' },
                React.createElement('div', { className: 'bb-admin-grid-toolbar' },
                    React.createElement('input', {
                        type: 'text',
                        placeholder: 'Search apps (name or package)',
                        value: this.state.appSearch,
                        onChange: this.onAppSearchChange
                    }),
                    React.createElement('button', { className: 'bb-btn bb-btn-secondary bb-btn-xs', onClick: this.reloadAppsDatasource }, 'Reload'),
                    React.createElement('select', {
                        value: this.state.appsBulkField,
                        onChange: function(e) { self.setState({ appsBulkField: e.target.value, appsBulkMessage: '' }); }
                    },
                        bulkFields.map(function(f) { return React.createElement('option', { key: f.value, value: f.value }, f.label); })
                    ),
                    React.createElement('input', {
                        type: 'text',
                        placeholder: 'Bulk value',
                        value: this.state.appsBulkValue,
                        onChange: function(e) { self.setState({ appsBulkValue: e.target.value, appsBulkMessage: '' }); }
                    }),
                    React.createElement('button', {
                        className: 'bb-btn bb-btn-secondary bb-btn-xs',
                        onClick: this.bulkUpdateSelectedApps,
                        disabled: this.state.appsBulkLoading || !this.state.appsSelectedCount
                    }, this.state.appsBulkLoading ? 'Working...' : ('Apply to selected' + (this.state.appsSelectedCount ? (' (' + this.state.appsSelectedCount + ')') : ''))),
                    isAdmin ? React.createElement('button', {
                        className: 'bb-btn bb-btn-danger bb-btn-xs',
                        onClick: this.bulkDeleteSelectedApps,
                        disabled: this.state.appsBulkLoading || !this.state.appsSelectedCount
                    }, 'Delete selected' + (this.state.appsSelectedCount ? (' (' + this.state.appsSelectedCount + ')') : '')) : null
                ),
                this.state.appsBulkMessage ? React.createElement('div', { className: 'bb-admin-hint', style: { marginTop: 0 } }, this.state.appsBulkMessage) : null,
                React.createElement(AdminAgTable, {
                    ref: this.appsTableRef,
                    columnDefs: this.appColumnDefs,
                    defaultColDef: this.appDefaultColDef,
                    frameworkComponents: { adminSelectFloatingFilter: AdminSelectFloatingFilter },
                    context: { componentParent: this },
                    pageSize: this.state.appsPageSize || 100,
                    onGetRows: this.appsOnGetRows,
                    rowSelection: 'multiple',
                    themeClass: 'ag-theme-bb-admin bb-admin-apps-grid',
                    height: '540px',
                    rowHeight: 56,
                    suppressCellFocus: true,
                    animateRows: true,
                    stopEditingWhenCellsLoseFocus: true,
                    onCellValueChanged: this.onAppCellValueChanged,
                    onSelectionChanged: this.onAppsSelectionChanged,
                    onFilterChanged: this.onAppsSelectionChanged,
                    onSortChanged: this.onAppsSelectionChanged,
                    getRowNodeId: function(data) { return data && data.package_name ? data.package_name : (data && data.id ? data.id : undefined); },
                    singleClickEdit: true
                }),
                pendingAppEdits ? React.createElement('div', { className: 'bb-admin-inline', style: { marginTop: '0.5rem' } },
                    React.createElement('button', {
                        className: 'bb-btn bb-btn-primary bb-btn-sm',
                        onClick: this.saveAppGridEdits,
                        disabled: this.state.appsSaving
                    }, this.state.appsSaving ? 'Saving...' : ('Save changes (' + pendingAppEdits + ')')),
                    this.state.appsSaveMessage ? React.createElement('div', { className: 'bb-admin-hint', style: { marginTop: 0 } }, this.state.appsSaveMessage) : null
                ) : null
            )
        );
    }

    renderComments() {
        var role = (this.props.user && this.props.user.role) || 'user';
        var isAdmin = role === 'admin' || role === 'superadmin' || role === 'moderator';
        var headers = ['Date', 'Package', 'User', 'Vote', 'Comment', 'Actions'];
        var rows = this.state.comments || [];
        return React.createElement('div', { className: 'bb-admin-section' },
            React.createElement('div', { className: 'bb-admin-inline', style: { justifyContent: 'space-between', alignItems: 'center' } },
                React.createElement('div', null, React.createElement('strong', null, 'Moderate Comments')),
                React.createElement('div', null,
                    React.createElement('input', {
                        type: 'text',
                        placeholder: 'Filter package',
                        value: this.state.commentPkg,
                        onChange: function(e) { this.setState({ commentPkg: e.target.value }); }.bind(this),
                        style: { marginRight: '0.5rem' },
                        className: 'bb-select'
                    }),
                    React.createElement('input', {
                        type: 'text',
                        placeholder: 'Filter user (username or id)',
                        value: this.state.commentUser,
                        onChange: function(e) { this.setState({ commentUser: e.target.value }); }.bind(this),
                        style: { marginRight: '0.5rem' },
                        className: 'bb-select'
                    }),
                    React.createElement('button', { className: 'bb-btn bb-btn-secondary bb-btn-sm', onClick: function() { this.reloadCommentsDatasource(); }.bind(this) }, 'Apply'),
                    null
                )
            ),
            this.state.commentResult ? React.createElement('div', { className: 'bb-admin-hint' }, this.state.commentResult) : null,
            this.state.voteDeleteMsg ? React.createElement('div', { className: 'bb-admin-hint' }, this.state.voteDeleteMsg) : null,
            React.createElement('div', { style: { width: '100%', marginTop: '0.5rem' } },
                (function() {
                    var blockSize = this.state.commentsPageSize || 100;
                    var columnDefs = this.commentsColumnDefs;
                    var defaultColDef = this.commentsDefaultColDef;

                    if (!this.state.showCommentsGrid) {
                        return React.createElement('div', { style: { height: '520px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' } }, 'Loading comments...');
                    }
                    return React.createElement(AdminAgTable, {
                        ref: this.commentsTableRef,
                        columnDefs: columnDefs,
                        defaultColDef: defaultColDef,
                        context: { componentParent: this },
                        pageSize: blockSize,
                        onGetRows: this.commentsOnGetRows,
                        rowSelection: 'multiple',
                        themeClass: 'ag-theme-bb-admin',
                        height: '520px'
                    });
                }).call(this)
            ),
            this.state.modalVisible ? React.createElement('div', { className: 'bb-modal-overlay', onClick: this.closeCommentModal.bind(this) },
                React.createElement('div', { className: 'bb-modal', onClick: function(e){ e.stopPropagation(); } },
                    React.createElement('h5', null, this.state.modalRow && this.state.modalRow.app_name ? this.state.modalRow.app_name : 'Comment'),
                    React.createElement('div', { style: { marginTop: '0.5rem', whiteSpace: 'pre-wrap' } }, this.state.modalRow && this.state.modalRow.comment ? this.state.modalRow.comment : ''),
                    React.createElement('div', { style: { marginTop: '0.75rem', textAlign: 'right' } }, React.createElement('button', { className: 'bb-btn bb-btn-secondary bb-btn-sm', onClick: this.closeCommentModal.bind(this) }, 'Close'))
                )
            ) : null
        );
    }

    render() {
        var self = this;
        var role = (this.props.user && this.props.user.role) || 'user';
        var isSuper = role === 'superadmin';
        var isAdmin = role === 'admin' || isSuper;
        var allowApps = !this.props.isLegacy && (isAdmin || role === 'moderator');
        var allowUsers = !this.props.isLegacy && isSuper;
        var tabs = [
            { key: 'stats', label: 'Stats' }
        ];
        if (isAdmin || role === 'moderator') tabs.push({ key: 'comments', label: 'Comments' });
        if (allowApps) tabs.push({ key: 'apps', label: 'Apps' });
        if (allowUsers) tabs.push({ key: 'users', label: 'Users' });

        return React.createElement('div', { className: 'container my-3' },
            React.createElement('div', { className: 'bb-profile-card' },
                React.createElement('div', { className: 'bb-profile-header' },
                    React.createElement('div', { className: 'bb-profile-avatar' },
                        this.props.user.avatar_url
                            ? React.createElement('img', { src: this.props.user.avatar_url, alt: this.props.user.username })
                            : React.createElement('div', { className: 'bb-profile-placeholder' }, (this.props.user.username || '?').charAt(0))
                    ),
                    React.createElement('div', null,
                        React.createElement('div', { className: 'bb-profile-name' }, '@' + (this.props.user.username || 'discorduser')),
                        React.createElement('div', { className: 'bb-profile-id' }, 'User ID: ' + this.props.user.id)
                    ),
                    React.createElement('div', { style: { marginLeft: 'auto', display: 'flex', alignItems: 'center' } },
                        React.createElement('button', {
                            className: 'bb-btn bb-btn-secondary bb-btn-xs',
                            onClick: this.props.onBack,
                            style: { marginRight: '0.5rem' }
                        }, 'Back'),
                        React.createElement('button', {
                            className: 'bb-btn bb-btn-secondary bb-btn-xs',
                            onClick: this.props.onLogout
                        }, 'Logout')
                    )
                ),
                this.props.isLegacy ? React.createElement('div', { className: 'bb-admin-hint' }, 'Admin tools are best used on desktop; only basic actions are shown.') : null,
                role === 'user' ? React.createElement('div', { className: 'bb-admin-hint' }, 'Limited access. Sign in as moderator/admin for management tools.') : null,
                React.createElement('div', { className: 'bb-admin-tabs' },
                    tabs.map(function(t) {
                        return React.createElement('button', {
                            key: t.key,
                            className: 'bb-filter-btn bb-filter-btn-sm' + (self.state.tab === t.key ? ' active' : ''),
                            onClick: function() { self.switchTab(t.key); }
                        }, t.label);
                    })
                ),
                this.state.tab === 'stats' ? this.renderStats() : null,
                this.state.tab === 'users' ? this.renderUsers() : null,
                this.state.tab === 'apps' ? this.renderApps() : null,
                this.state.tab === 'comments' ? this.renderComments() : null
            )
        );
    }
}

export default AdminPage;
